import React from 'react'

const Bullet = ({ component, className }) => {
  const { text, url } = component
  if (!text) return
  if (!url) {
    return (
      <span
        className={`bg-naranja-900 text-white rounded-full inline-block px-3 py-2 text-sm leading-4 tracking-tight mr-2 mb-2 ${className}`}>
        {text}
      </span>
    )
  }
  return (
    <a
      className={`bg-naranja-900 text-white rounded-full inline-block px-3 py-2 text-sm leading-4 tracking-tight mr-2 mb-2 ${className}`}
      href={url}>
      {text}
    </a>
  )
}

export default Bullet
